import React from "react";
import CustomData from "pages/_components/CustomData/CustomData";
import { shape, string } from "prop-types";
import * as i18n from "util/i18n";
import { isDesktop } from "react-device-detect";

const CedipConfirmationBody = ({ beneficiary, amount, selectedActionCedip }) => (
    <div className="ticket__body cedip-massive-emit">
        <div className={isDesktop ? "ticket-section three-cols" : "ticket-section one-col"}>
            <CustomData
                titleText="cedip.transmit.ticket.cuit.beneficiary"
                titleTextType="I18N"
                valueText={beneficiary?.document.split(" ")[1]}
            />
            <CustomData
                titleText="cedip.transmit.ticket.business.name"
                titleTextType="I18N"
                valueText={beneficiary?.reference || "-"}
            />
            <CustomData
                keepSpaceIfNotitle
                titleTextType="I18N"
                titleText="cedip.transmit.ticket.amount"
                valueText={
                    selectedActionCedip === "CEDIP-TRANSMIT" && amount?.quantity !== undefined
                        ? amount.quantity
                        : amount
                }
                valueTextType="ARS"
            />
            <CustomData
                titleText="cedip.transmit.ticket.transmission.type"
                titleTextType="I18N"
                valueText={i18n.get("cedips.transmissions.type.NOM")}
            />
        </div>
    </div>
);

CedipConfirmationBody.propTypes = {
    beneficiary: shape({}).isRequired,
    amount: string.isRequired,
    selectedActionCedip: string.isRequired,
};

export default CedipConfirmationBody;
